/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Reviews_Alreadyreviewed2Inputs */

const id_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah diulas`)
};

const ms_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah diulas`)
};

const da_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allerede anmeldt`)
};

const de_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits bewertet`)
};

const en_us2_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already reviewed`)
};

const es_es2_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya reseñado`)
};

const es_mx2_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya reseñado`)
};

const fil_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na-review na`)
};

const fr_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà noté`)
};

const it_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Già recensito`)
};

const hu_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Már értékeltél`)
};

const nl_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Al beoordeeld`)
};

const no_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allerede omtalt`)
};

const pl_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Już recenzowane`)
};

const pt_br2_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já revisado`)
};

const pt_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já avaliado`)
};

const ro_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja recenzat`)
};

const fi_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arvosteltu jo`)
};

const sv_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redan recenserad`)
};

const vi_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã đánh giá`)
};

const tr_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaten yorum yapıldı`)
};

const cs_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Již recenzováno`)
};

const bg_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вече е ревюирано`)
};

const ru_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор уже написан`)
};

const uk_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вже залишено відгук`)
};

const ar_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمت المراجعة بالفعل`)
};

const hi_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पहले ही समीक्षा की जा चुकी है`)
};

const th_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รีวิวแล้ว`)
};

const ja_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビュー済み`)
};

const zh_cn2_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已发表评论`)
};

const zh_hant1_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已發表評論`)
};

const ko_offerdetail_reviews_alreadyreviewed2 = /** @type {(inputs: Offerdetail_Reviews_Alreadyreviewed2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 리뷰 작성함`)
};

/**
* | output |
* | --- |
* | "Already reviewed" |
*
* @param {Offerdetail_Reviews_Alreadyreviewed2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_reviews_alreadyreviewed2 = /** @type {((inputs?: Offerdetail_Reviews_Alreadyreviewed2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Reviews_Alreadyreviewed2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "ms") return ms_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "da") return da_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "de") return de_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "fil") return fil_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "fr") return fr_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "it") return it_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "hu") return hu_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "nl") return nl_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "no") return no_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "pl") return pl_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "pt") return pt_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "ro") return ro_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "fi") return fi_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "sv") return sv_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "vi") return vi_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "tr") return tr_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "cs") return cs_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "bg") return bg_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "ru") return ru_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "uk") return uk_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "ar") return ar_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "hi") return hi_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "th") return th_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "ja") return ja_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_reviews_alreadyreviewed2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_reviews_alreadyreviewed2(inputs)
	return ko_offerdetail_reviews_alreadyreviewed2(inputs)
});
export { offerdetail_reviews_alreadyreviewed2 as "offerDetail.reviews.alreadyReviewed" }